import { useQuery } from "@tanstack/react-query"
import { FeedbackGet } from "../app/models/Feedback"
import { digitalManagerApi } from "../services/api"

export function useFeedbacks() {
  const { data: feedbacksList = [], isLoading: isLoadingFeedbacks } = useQuery({
    queryKey: ["feedbacks"],
    queryFn: () => digitalManagerApi.get<FeedbackGet[]>(`/feedbacks`).then((r) => r.data),
  })

  return {
    feedbacksList,
    isLoadingFeedbacks,
  }
}
